import {AuthService} from './auth.service';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  URL: string;

  constructor(
    private http: HttpClient,
    private auth: AuthService
  ) {
    this.URL = `${environment.baseServerURL}/administration`;
  }

  buildURL(subPath: string) {
    return `${this.URL}/${this.auth.user.company.id}/category/${subPath}`;
  }

  getCategoriesList(): Observable<any> {
    return this.http.get(this.buildURL(''), {
      withCredentials: true
    });
  }

  getFavoriteCategoriesList(): Observable<any> {
    return this.http.get(this.buildURL('favorite'), {
      withCredentials: true
    });
  }

  createCategory(category): Observable<any> {
    return this.http.post(this.buildURL(''), category, {
      withCredentials: true
    });
  }

  updateCategory(category): Observable<any> {
    return this.http.put(this.buildURL(category.id), category, {
      withCredentials: true
    });
  }

  deleteCategory(id): Observable<any> {
    return this.http.delete(this.buildURL(id), {
      withCredentials: true
    });
  }

  loadCategory(id): Observable<any> {
    return this.http.post(this.buildURL(`load/${id}`), {}, {
      withCredentials: true
    });
  }

}
